// extracted by mini-css-extract-plugin
export default {"title":"SafetyAlertTitle_title__7a4HW","title--active":"SafetyAlertTitle_title--active__j00rQ"};